// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__1Kkp4","label":"CategoryService_label__1aPFU","location":"CategoryService_location__1Wmtb"};